import { useEffect } from 'react';
import { useAuthStore } from '../../stores/auth.js';

function decodeJwtExp(token: string): number | null {
  try {
    const [, payload] = token.split('.');
    if (!payload) return null;
    const json = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    return typeof json.exp === 'number' ? json.exp : null;
  } catch {
    return null;
  }
}

/**
 * On tab focus, checks whether the stored access token has expired.
 * If expired, attempts a single-flight refresh; on failure, clears auth
 * state and redirects to /login.
 */
export function useAutoLogout() {
  useEffect(() => {
    const onVisibility = async () => {
      if (document.visibilityState !== 'visible') return;
      const { accessToken, clear } = useAuthStore.getState();
      if (!accessToken) return;
      const exp = decodeJwtExp(accessToken);
      if (exp && exp * 1000 < Date.now()) {
        try {
          const { triggerRefresh } = await import('../../lib/api/client.js');
          await triggerRefresh();
        } catch {
          clear();
          window.location.href = '/login';
        }
      }
    };
    document.addEventListener('visibilitychange', onVisibility);
    return () => document.removeEventListener('visibilitychange', onVisibility);
  }, []);
}
